import { isProdEnv } from 'utils/utilities';
import packageJson from '../../../package.json';

export const TRACKING_VERSION = 2;

export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN?.trim();

export const INSTANCE_NAME = 'analytics_v2';

// Same token as v1. `persistence_name` keeps v2's identity and super properties out of v1's
// `mp_<token>_mixpanel` store; the `__mpq_<token>` batch queues are still shared, which is harmless
// while both instances send to the same project and host.
export const MIXPANEL_CONFIG = {
    persistence: 'localStorage',
    persistence_name: INSTANCE_NAME,
    debug: !isProdEnv(),
    track_pageview: false,
    autocapture: false,
    record_sessions_percent: 0,
};

// sendBeacon outlives pagehide; send_immediately skips the batch queue, which would otherwise
// only flush on the user's next visit.
export const EXIT_TRACK_OPTIONS = { transport: 'sendBeacon', send_immediately: true };

// Literal keys let webpack keep only these two entries of package.json in the bundle.
export const SDK_VERSIONS = {
    REGULA: packageJson.dependencies['@regulaforensics/vp-frontend-document-components'],
    AWS_LIVENESS: packageJson.dependencies['@aws-amplify/ui-react-liveness'],
};

export const PROFILE_KEYS = ['company_name', 'company_uuid'];

export const PII_KEYS = new Set([
    'first_name',
    'last_name',
    'full_name',
    'name',
    'email',
    'phone',
    'dob',
    'date_of_birth',
    'address',
    'ssn',
    'document_number',
    'image',
]);
